/** The curated set: every glyph by name, grouped by category for the gallery. */
import type { Glyph } from './geom.js';
import { UI } from './ui.js';
import { PLACES } from './places.js';
import { DEVICES } from './devices.js';
import { READINGS } from './readings.js';

/** Names kept for older call sites; each points at a glyph in the set. */
export const ALIASES: Record<string, string> = {
  boost: 'bolt',
  'lock-open': 'unlock',
  'lock-locked': 'lock',
  'battery-full': 'battery-100',
  downlight: 'downlights',
  'wall-light': 'sconce',
  'table-lamp': 'lamp',
  'under-cabinet': 'cabinet-light',
  dog: 'paw',
  cat: 'paw',
  'plant-room': 'pipes',
  'blind-0': 'blind',
  'blind-100': 'blind-open',
  'shutter-0': 'shutter',
  'shutter-100': 'shutter-open',
  energy: 'meter',
  grid_power: 'pylon',
  'wifi-4': 'wifi',
  'door-closed': 'door',
  'window-closed': 'window',
  heating: 'flame',
  cooling: 'snowflake',
  study: 'desk',
  gym: 'dumbbell',
  'fresh-air': 'damper',
  voc: 'molecule',
  phone_mobile: 'phone',
};

export const ICON_CATEGORIES: Array<{ id: string; label: string; icons: Record<string, Glyph> }> = [
  { id: 'devices', label: 'Devices', icons: DEVICES },
  { id: 'readings', label: 'Readings, weather & time', icons: READINGS },
  { id: 'places', label: 'Places, people & things', icons: PLACES },
  { id: 'ui', label: 'App chrome', icons: UI },
];

export const GLYPHS: Record<string, Glyph> = { ...UI, ...PLACES, ...DEVICES, ...READINGS };
for (const [alias, target] of Object.entries(ALIASES)) {
  const g = GLYPHS[target];
  if (g && !(alias in GLYPHS)) GLYPHS[alias] = g;
}

export const hasIcon = (name: string): boolean => name in GLYPHS;
